import React, { Component } from 'react';
import { Modal, Button, Table } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class UpdateLog extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
    }

    show = (record = {}) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            record: {},
            visible: false,
        });
    }

    loadData = () => {
        const { record: { ptPriceRecordId } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.contract.queryPtPriceRecordLog,
            data: { 
                ptPriceRecordId, 
            },
            dataType: 'json',
            doneResult: res => {
                const { ptPriceRecordLogs } = res; 
                this.setState({
                    data: ptPriceRecordLogs,
                    loading: false,
                })
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => [{
        title: '更新时间',
        dataIndex: 'updateTime',
        key: 'updateTime',
        width: 120,
    }, {
        title: '更新人',
        dataIndex: 'user',
        key: 'user',
        width: 120,
        render: (text, record) => {
            const { userName, userCode } = record;
            return (userName && userCode) ? `${userName}[${userCode}]` : ''
        }
    }, {
        title: '更新字段',
        dataIndex: 'updateFiled',
        key: 'updateFiled',
        width: 120,
    }, {
        title: '更新前',
        dataIndex: 'beforeData',
        key: 'beforeData',
        width: 120,
    }, {
        title: '更新后',
        dataIndex: 'updateData',
        key: 'updateData',
        width: 120,
    }]

    render() {
        const { visible, loading, data, record } = this.state;
        const { reimbursementNum, customerCompanyNameCode, jdeMainCode } = record;
        return (
            <Modal
                title="更新日志"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                maskClosable={false}
                width="1000px"
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <div style={{ display: 'flex', margin:'15px 0' }}>
                        <div style={{ marginRight: 10 }}>报销单号：{reimbursementNum}</div>
                        <div style={{ marginRight: 10 }}>客户名称：{customerCompanyNameCode}</div>
                        <div>JDE项目号：{jdeMainCode}</div>
                    </div>
                    <div>
                        <Table
                            dataSource={data}
                            loading={loading}
                            columns={this.getColumns()}
                            pagination={false}
                        />
                        <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
                    </div>
                </div>
            </Modal>
        );
    }
}

export default UpdateLog;


// WEBPACK FOOTER //
// ./src/components/contractManagement/ptReimburse/UpdateLog.js